var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-modal",style:(_vm.windowCls)},[_c(_vm.spec.view,{tag:"component",attrs:{"args":_vm.args},on:{"onResult":_vm.onResult}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }